import { marqueeItems } from "@/data/content";

export default function Marquee() {
  const row = [...marqueeItems, ...marqueeItems];
  return (
    <div data-testid="editorial-marquee" className="bg-azure text-white py-4 overflow-hidden border-y border-white/10">
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif italic text-lg sm:text-xl px-6">{item}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
}
